window.Page = {

    // Let's launch this thing
    liftoff : () => {},

};

Page.liftoff()